import "./OfficeDetails.css";
import Navbar from "../components/Navbar/Navbar";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import OfficeDetailsCard from "./OfficeDetailsCard";
import { Company } from "../models/company";
import { apiCall } from "../api/apiCall";
import TopHeader from "../components/Navbar/TopHeader";
import { useTranslation } from "../i18n/UseTranslation";
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

function OfficeDetails({ showNavbar = true }: { showNavbar?: boolean }) {
  const { t } = useTranslation();
  const { companyUuid } = useParams<{ companyUuid: string }>();

      const [isAuthReady, setIsAuthReady] = useState(false);
  
  
  useEffect(() => {
        const auth = getAuth(); 
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          setIsAuthReady(true);
        });
        return () => unsubscribe();
      }, []);


  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["officeDetails", companyUuid],
    enabled: !!companyUuid && isAuthReady,
    queryFn: async () => {
      return await apiCall<Company>(`/companies/${companyUuid}`);
    },
  });

  if (isLoading) return <p className="office-loading">{t.officeDetails.loading}</p>;
  if (isError) return <p className="office-error">{t.officeDetails.errorPrefix} {(error as Error).message}</p>;
  if (!data) return <p className="office-error">{t.officeDetails.notFound}</p>;

  return (
    <div
      className="office-details-container"
      
    >
      {showNavbar && <Navbar />}
      <TopHeader />

      <div className="office-details-wrapper">
        <OfficeDetailsCard company={data} />
      </div>
    </div>
  );
}

export default OfficeDetails;